import classnames from "classnames";
import CustomerCard from "./components/CustomerCard";
import PickUpCard from "./components/PickUpCard";
import DeliverCard from "./components/DeliverCard";
import DataCard from "./components/DataCard";
import RateCard from "./components/RateCard";
import NotesCard from "./components/NotesCard";
import MapCard from "./components/MapCard";
import MapCardNew from "./components/MapCardNew";

import { useContext, useEffect, useState } from "react";
import { Context } from "pages/Dashboard/Dashboard";

const RfqInformation = ({
  condition,
  rfqData,
  className,
  loadingClass,
  showDetailedInfo,
  byOrderIdData,
}) => {
  const { bidDetailsData } = useContext(Context);
  const {
    customer,
    linkToOrder,
    orderNumber,
    pickUp,
    delivery,
    approxRates,
    notes,
    miles,
    suggestedTruckSize,
    cargo,
  } = bidDetailsData?.rfq || {};

  //TODO: create refactor again without this fucking ternan checks
  const [data, setData] = useState()
  useEffect(()=> {
    setData(dataForDisplay())
  }, [rfqData, byOrderIdData])

  const dataForDisplay = () => {
    if(byOrderIdData?.rfq) {
      return byOrderIdData.rfq
    } else return rfqData
  }

  const mainData = {
    miles: !showDetailedInfo ? data?.miles : miles,
    size: !showDetailedInfo ? data?.suggestedTruckSize : suggestedTruckSize,
    cargo: !showDetailedInfo ? data?.cargo : cargo,
  };

  const cardClass = classnames(className, loadingClass);

  return (
    <>
      <CustomerCard
        className={cardClass}
        customer={!showDetailedInfo ? data?.customer : customer}
        orderNumber={!showDetailedInfo ? data?.orderNumber : orderNumber}
        linkToOrder={!showDetailedInfo ? data?.linkToOrder : linkToOrder}
        condition={condition}
      />
      <PickUpCard
        className={cardClass}
        pickUp={!showDetailedInfo ? data?.pickUp : pickUp}
        minHeight={condition ? "17.8rem" : "15.2rem"}
      />
      <DeliverCard
        className={cardClass}
        delivery={!showDetailedInfo ? data?.delivery : delivery}
        minHeight={condition ? "17.8rem" : "15.2rem"}
      />
      <DataCard
        className={cardClass}
        data={mainData}
        minHeight={condition ? "38rem" : "32rem"}
      />
      <RateCard
        className={cardClass}
        approxRates={!showDetailedInfo ? data?.approxRates : approxRates}
        condition={condition}
      />
      <MapCardNew rfqData={!showDetailedInfo ? data: bidDetailsData?.rfq} loadingClass={loadingClass} />
      <NotesCard
        className={cardClass}
        notes={!showDetailedInfo ? data?.notes : notes}
      />
    </>
  );
};

export default RfqInformation;
